<template>
  <div>
    <div v-if="popup_datas !== ''" class="popups-container" @touchmove.stop>
      <div @click.stop :class="['popups-wrapper',bg]">
        <div class="msg" v-if="popup_datas.type == 'h_tips'">{{popup_datas.msg}}</div>
        <div
          class="wrapper"
          v-if="popup_datas.type == 'h_policy'||popup_datas.type == 'h_agreement'"
        >
          <!-- <div class="notice">{{ $t("message.notice") }}</div> -->
          <div class="msg"   v-html="popup_datas.msg"></div>
        </div>
      </div>
      <div class="colse" @click="shareClose"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "popup",
  components: {},
  methods: {
    //分享弹窗出来的时候 阻止页面滚动
    stopBodyScroll(isFixed) {
      var bodyEl = document.body;
      if (isFixed) {
        this.top = window.scrollY;
        bodyEl.style.position = "fixed";
        bodyEl.style.top = -this.top + "px";
      } else {
        bodyEl.style.position = "";
        bodyEl.style.top = "";
        window.scrollTo(0, this.top); // 回到原先的top
      }
    },
    shareClose() {
      this.stopBodyScroll(false);
      this.$store.dispatch("set_popup_datas", "");
    }
  },
  computed: {
    ...mapGetters(["popup_datas"])
  },
  data() {
    return {
      top: "",
      bg: ""
      //   popup_datas: "ddd "
    };
  },
  watch: {
    popup_datas() {
      if (this.popup_datas.type === "h_tips") {
        this.stopBodyScroll(true);
        this.bg = "h_tip";
      }
      if (this.popup_datas.type === "h_policy") {
        this.stopBodyScroll(true);
        this.bg = "h_policy";
      }
      if (this.popup_datas.type === "h_agreement") {
        this.stopBodyScroll(true);
        this.bg = "h_agreement";
      }
    }
  }
};
</script>
<style lang="less" scoped>
.popups-container {
  background: rgba(0, 0, 0, 0.75);
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  .popups-wrapper {
    position: relative;
    width: 628px;
    height: 467px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #932c2c;
    text-align: center;
    overflow: hidden;
    .wrapper {
      position: relative;
      width: 700px;
      margin-top: 50px;
      height: 300px;
      overflow-x: hidden;
      overflow-y: scroll;
      word-wrap: break-word;
      &::-webkit-scrollbar {
        display: none;
      }
      // .notice {
      //   position: relative;
      //   margin-top: 10px;
      //   margin-bottom: 10px;
      //   left: 100px;
      //   text-align: left;
      //   color: #932c2c;
      //   height: 25px;
      //   line-height: 25px;
      //   background: #edcfbc;
      //   width: 500px;
      // }
      .msg {
        margin-top: 10px;
        text-align: left;
        position: relative;
        left: 100px;
        width: 500px;
      }
    }
  }
  .colse {
    position: relative;
    width: 112px;
    height: 122px;
    background-image: url("../assets/img/popup/close.png");
    background-size: 100% 100%;
  }
}
.h_tip {
  background-image: url("../assets/img/popup/pc.png");
  background-size: 100% 100%;
}
.h_policy {
  background-image: url("../assets/img/popup/policy.png");
  background-size: 100% 100%;
}
.h_agreement {
  background-image: url("../assets/img/popup/agreement.png");
  background-size: 100% 100%;
}
@media screen and (max-width: 640px) {
  .popups-container {
    width: 100vw;
    height: 100vh;
    .popups-wrapper {
      width: 6.98rem;
      height: 4.97rem;
      .wrapper {
        position: relative;
        width: 7rem;
        margin-top: 0.45rem;
        height: 3.2rem;
        overflow-x: hidden;
        overflow-y: scroll;
        &::-webkit-scrollbar {
          display: none;
        }
        // .notice {
        //   position: relative;
        //   margin-top: 0.1rem;
        //   margin-bottom: 0.1rem;
        //   left: 0.52rem;
        //   text-align: left;
        //   color: #932c2c;
        //   height: 0.5rem;
        //   line-height: 0.5rem;
        //   background: #edcfbc;
        //   width: 6rem;
        // }
        .msg {
           margin-top: 0.1rem;
          text-align: left;
          position: relative;
          left: 0.52rem;
          width: 6rem;
        }
      }
    }
    .colse {
      position: relative;
      width: 1.12rem;
      height: 1.22rem;
    }
  }
}
</style>
